(function () {
  var SECTION_SELECTOR = "[data-cd-home-faq]";

  function refreshHeader() {
    if (
      window.CDCleerHeaderTheme &&
      typeof window.CDCleerHeaderTheme.refresh === "function"
    ) {
      window.CDCleerHeaderTheme.refresh();
    }
  }

  function removeInlineTextOverrides(section) {
    if (!section) return;

    var textOverrideProps = [
      // "color",
      "font-family",
      "font-size",
      "font-weight",
      "line-height",
      "letter-spacing",
      "border-color"
    ];

    var nodes = [section].concat(
      Array.prototype.slice.call(
        section.querySelectorAll(
          [
            ".cd-home-faq__heading",
            ".cd-home-faq__heading [style]",
            ".cd-home-faq__trigger",
            ".cd-home-faq__trigger [style]",
            ".cd-home-faq__question",
            ".cd-home-faq__question [style]",
            ".cd-home-faq__answer-wrap",
            ".cd-home-faq__answer-wrap [style]",
            ".cd-home-faq__answer",
            ".cd-home-faq__answer [style]",
            ".cd-home-faq__item",
            ".cd-home-faq__item [style]",
            ".cd-home-faq__topline",
            ".cd-home-faq__topline [style]"
          ].join(", "),
        ),
      ),
    );

    Array.prototype.forEach.call(nodes, function (node) {
      if (!(node instanceof HTMLElement)) return;

      textOverrideProps.forEach(function (prop) {
        node.style.removeProperty(prop);
      });

      var remainingStyle = node.getAttribute("style");

      if (remainingStyle && remainingStyle.trim() === "") {
        node.removeAttribute("style");
      }
    });
  }

  function observeInlineTextOverrides(section) {
    if (!section || section.dataset.cdFaqInlineObserver === "true") return;
    if (!("MutationObserver" in window)) return;

    section.dataset.cdFaqInlineObserver = "true";

    var queued = false;

    var inlineStyleObserver = new MutationObserver(function () {
      if (queued) return;

      queued = true;

      window.requestAnimationFrame(function () {
        queued = false;
        removeInlineTextOverrides(section);
      });
    });

    inlineStyleObserver.observe(section, {
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  function revealSection(section) {
    if (!section || section.classList.contains("is-inview")) return;
    section.classList.add("is-inview");
    refreshHeader();
  }

  function setPanelState(item, open, animate) {
    var trigger = item.querySelector("[data-cd-faq-trigger]");
    var panel = item.querySelector("[data-cd-faq-panel]");
    if (!trigger || !panel) return;

    item.classList.toggle("is-open", open);
    trigger.setAttribute("aria-expanded", open ? "true" : "false");

    if (!animate) {
      panel.style.maxHeight = open ? "none" : "0px";
      return;
    }

    if (open) {
      panel.style.maxHeight = panel.scrollHeight + "px";
      window.setTimeout(function () {
        if (item.classList.contains("is-open")) {
          panel.style.maxHeight = "none";
        }
      }, 420);
      return;
    }

    if (panel.style.maxHeight === "none" || !panel.style.maxHeight) {
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.offsetHeight;
    }
    panel.style.maxHeight = "0px";
  }

  function closeSiblings(section, activeItem) {
    var items = section.querySelectorAll("[data-cd-faq-item]");
    Array.prototype.forEach.call(items, function (item) {
      if (item === activeItem) return;
      if (!item.classList.contains("is-open")) return;
      setPanelState(item, false, true);
    });
  }

  function syncOpenPanels(section) {
    var items = section.querySelectorAll("[data-cd-faq-item]");
    Array.prototype.forEach.call(items, function (item) {
      setPanelState(item, item.classList.contains("is-open"), false);
    });
  }

  function bindAccordion(section) {
    var items = section.querySelectorAll("[data-cd-faq-item]");
    Array.prototype.forEach.call(items, function (item) {
      var trigger = item.querySelector("[data-cd-faq-trigger]");
      if (!trigger || trigger.dataset.cdFaqBound === "true") return;
      trigger.dataset.cdFaqBound = "true";

      trigger.addEventListener("click", function () {
        var shouldOpen = !item.classList.contains("is-open");
        closeSiblings(section, item);
        setPanelState(item, shouldOpen, true);
      });
    });
  }

  function initObserver(section) {
    if (!("IntersectionObserver" in window)) {
      revealSection(section);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealSection(section);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.18,
        rootMargin: "0px 0px -8% 0px",
      },
    );

    observer.observe(section);
  }

  function initSection(section) {
    if (!section || section.dataset.cdHomeFaqReady === "true") return;
    section.dataset.cdHomeFaqReady = "true";

    removeInlineTextOverrides(section);
    observeInlineTextOverrides(section);
    bindAccordion(section);
    syncOpenPanels(section);
    initObserver(section);
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    Array.prototype.forEach.call(sections, initSection);
  }

  function handleResize() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    Array.prototype.forEach.call(sections, function (section) {
      var openItems = section.querySelectorAll("[data-cd-faq-item].is-open");
      Array.prototype.forEach.call(openItems, function (item) {
        var panel = item.querySelector("[data-cd-faq-panel]");
        if (!panel) return;
        panel.style.maxHeight = "none";
      });
    });
    refreshHeader();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  window.addEventListener("resize", handleResize);
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
